// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import HouseboatIcon from '@mui/icons-material/Houseboat';
import ListAltIcon from '@mui/icons-material/ListAlt';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc,
    ManageAccountsIcon
};

const icoMenu = {
    ManageAccountsIcon,
    HouseboatIcon,
    ListAltIcon,
    CurrencyExchangeIcon
}

// ==============================|| CONTABILIDAD MENU ITEMS ||============================== //

const userAdministracion = {
    id: 'userAdministracion',
    title: '',
    type: 'group',
    children: [
        {
            id: 'administracionMainMenu',
            title: 'Administración',
            type: 'collapse',
            icon: icoMenu.ManageAccountsIcon,
            children: [
                {
                    id: 'vacaciones',
                    title: 'Vacaciones',
                    type: 'item',
                    icon: icoMenu.HouseboatIcon,
                    url: '/user/new-vacaciones/0'
                },
                {
                    id: 'lista_vacaciones',
                    title: 'Lista Vacaciones',
                    type: 'item',
                    icon: icoMenu.ListAltIcon,
                    url: '/user/list-vacaciones'
                },
                {
                    id: 'prestamos',
                    title: 'Prestamos',
                    type: 'item',
                    icon: icoMenu.CurrencyExchangeIcon,
                    url: '/user/new-prestamos/0'
                },
                {
                    id: 'lista_prestamos',
                    title: 'Lista Prestamos',
                    type: 'item',
                    icon: icoMenu.ListAltIcon,
                    url: '/user/list-prestamos'
                },
            ]
        }     
    ]
};

export default userAdministracion;
